// extracted by mini-css-extract-plugin
module.exports = {"list":"QuickLinks_list__3A_51","link":"QuickLinks_link__3LCgx"};